const miscellanious = [
  {
    id: "all_rights_reserved",
    text: "™ 2025 Castell Group. All rights reserved.",
  },
];

export { miscellanious };
